import { PaginationModel } from './pagination.types';

export const DEFAULT_PAGINATION_STATE: PaginationModel = {
  currentPage: 0,
  initialPage: 0,
  pageSize: 0,
  isLastPage: false,
};
